import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import PlanToggle, { PLANS } from "@/components/PlanToggle";

export default function PaywallModal({ onClose }) {
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState("yearly");
  const p = PLANS[plan];
  const upgrade = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, plan });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Checkout failed");
    } finally { setLoading(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="bg-[#141618] border-[#282C30] text-[#F4F1EA] max-w-md" data-testid="paywall-modal">
        <DialogHeader>
          <div className="flex items-center justify-between gap-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676]">UNLOCK CLAWBACK</div>
            <PlanToggle plan={plan} onChange={setPlan} testid="paywall-plan-toggle" />
          </div>
          <DialogTitle className="font-display text-3xl tracking-tight" data-testid="paywall-price">
            ${p.price}{p.label}.
          </DialogTitle>
          <DialogDescription className="text-[#A0A7B0]">
            You're previewing with sample data. Membership unlocks real cancels, AI refund petitions, class-action claims and the nightly brief. {p.note} 0% of your payout.
          </DialogDescription>
        </DialogHeader>
        <ul className="text-sm text-[#A0A7B0] space-y-2 mt-2">
          <li className="flex gap-2"><Sparkles className="h-4 w-4 text-[#00E676] shrink-0 mt-0.5" /> Platform-correct cancel (Apple, Google, TikTok, short-drama)</li>
          <li className="flex gap-2"><Sparkles className="h-4 w-4 text-[#00E676] shrink-0 mt-0.5" /> AI-drafted refund petitions & bank dispute letters</li>
          <li className="flex gap-2"><Sparkles className="h-4 w-4 text-[#00E676] shrink-0 mt-0.5" /> Refund watch — escalates automatically at day 14</li>
          <li className="flex gap-2"><Sparkles className="h-4 w-4 text-[#00E676] shrink-0 mt-0.5" /> Nightly Claude brief + trial tripwires</li>
        </ul>
        <Button className="btn-emerald w-full h-11 mt-4" onClick={upgrade} disabled={loading} data-testid="paywall-upgrade-button">
          {loading ? "Redirecting…" : `Start membership — ${p.cta}`}
        </Button>
        <button onClick={onClose} className="mt-2 text-xs text-[#606872] hover:text-[#A0A7B0]" data-testid="paywall-close-button">
          Not now
        </button>
      </DialogContent>
    </Dialog>
  );
}
